// tslint:disable:no-any no-var-requires

import firebase from 'firebase'
require('firebase/functions') // required for side-effects https://firebase.google.com/docs/functions/callable
import { isDev } from '~/utils'


const devConfig = {
  apiKey: 'AIzaSyBIc4YrIrL7g_pDsmXaNcetgrJrSdpQqjE',
  authDomain: 'future-cloud-mining.firebaseapp.com',
  databaseURL: 'https://future-cloud-mining.firebaseio.com',
  messagingSenderId: '745885150789',
  projectId: 'future-cloud-mining',
  storageBucket: 'future-cloud-mining.appspot.com',
}

const prodConfig = devConfig // TODO production firebase

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig

if (isDev) (window as any)._firebase = firebase
if (isDev) (window as any)._app = {}

export const app = firebase.initializeApp(config)
export const auth = app.auth()
export const database = app.database()
export const functions = app.functions()
export const isAuthenticated = () => auth.currentUser != null
export const currentUID = () => auth.currentUser!.uid
export const SERVER_TIMESTAMP = firebase.database.ServerValue.TIMESTAMP as number

export * from './firebase.actions'
// export * from './firebase.functions'

// export const getUser = firebase.functions().httpsCallable('getUser')

export function getAccountRef(uid = currentUID())   { return database.ref(`users/${uid}`) }
export function getOrdersRef(uid = currentUID())    { return database.ref(`orders/${uid}`) }
export function getPurchasesRef(uid = currentUID()) { return database.ref(`purchases/${uid}`) }
export function getProductsRef()     { return database.ref('products') }
export function getYieldETHRef()     { return database.ref(`yield/eth`) }
export function getYieldETHRefTest() { return database.ref(`yield/eth-test`) }

export const ERROR_REAUTH_REQUIRED = 'auth/requires-recent-login'
export const PROVIDERS = [
  firebase.auth.GoogleAuthProvider,
  firebase.auth.FacebookAuthProvider,
  firebase.auth.TwitterAuthProvider,
  firebase.auth.GithubAuthProvider,
  firebase.auth.EmailAuthProvider,
  // firebase.auth.PhoneAuthProvider
]
export const PROVIDERS_IDS = PROVIDERS.map(provider => provider.PROVIDER_ID)



// WEBPACK FOOTER //
// ./src/firebase.ts